export default __webpack_public_path__ + "static/media/SMB_Logo_WithTM.a01c8853.png";